'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('components/Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Logo = require('components/Logo/Logo');

var _Logo2 = _interopRequireDefault(_Logo);

var _PageLink = require('containers/PageLink');

var _PageLink2 = _interopRequireDefault(_PageLink);

var _nav = require('./nav.css');

var _nav2 = _interopRequireDefault(_nav);

var _generalNav = require('./generalNav.css');

var _generalNav2 = _interopRequireDefault(_generalNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Navigation = function (_Component) {
  _inherits(Navigation, _Component);

  function Navigation() {
    _classCallCheck(this, Navigation);

    var _this = _possibleConstructorReturn(this, (Navigation.__proto__ || Object.getPrototypeOf(Navigation)).call(this));

    _this.state = {
      isNavOpen: false
    };
    return _this;
  }

  _createClass(Navigation, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({
        width: window.innerWidth
      });

      this.resizeHandler = this.onResize.bind(this);

      window.addEventListener('resize', this.resizeHandler);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.resizeHandler);
    }
  }, {
    key: 'openNav',
    value: function openNav() {
      this.setState({
        isNavOpen: true
      });
    }
  }, {
    key: 'closeNav',
    value: function closeNav(e) {
      this.setState({
        isNavOpen: false
      });
    }
  }, {
    key: 'onResize',
    value: function onResize() {
      this.setState({
        width: window.innerWidth
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isHome = _props.isHome,
          isDark = _props.isDark;
      var _state = this.state,
          isNavOpen = _state.isNavOpen,
          width = _state.width;

      var activeClassName = _generalNav2.default.itemActive;
      var generalNavClass = isHome ? _generalNav2.default.holderHidden : _generalNav2.default.holder;
      var generalNavClassMobile = !isNavOpen ? _generalNav2.default.holderHidden : _generalNav2.default.holder;
      var itemClass = isDark ? _generalNav2.default.itemDark : _generalNav2.default.item;
      var itemButtonClass = isDark ? _generalNav2.default.itemButtonDark : _generalNav2.default.itemButton;
      var openClass = _generalNav2.default.open;
      var openClassDark = isNavOpen ? _generalNav2.default.openDark : _generalNav2.default.openDark;
      var closeClass = _generalNav2.default.close;

      return _react2.default.createElement(
        'div',
        { className: _nav2.default.nav },
        _react2.default.createElement(
          'div',
          { className: _nav2.default.inner },
          _react2.default.createElement(_Logo2.default, {
            isDark: isDark,
            className: _nav2.default.logo
          }),
          _react2.default.createElement(
            'div',
            { className: isDark ? openClassDark : openClass, onClick: this.openNav.bind(this) },
            _react2.default.createElement(_Icon2.default, { type: 'hamburger', width: 22, height: 20 })
          ),
          _react2.default.createElement(
            'div',
            { className: width < 800 ? generalNavClassMobile : generalNavClass },
            _react2.default.createElement(
              'div',
              { className: closeClass, onClick: this.closeNav.bind(this) },
              _react2.default.createElement(_Icon2.default, { type: 'cross', width: 20, height: 20 })
            ),
            _react2.default.createElement(
              _PageLink2.default,
              {
                isDark: isDark,
                className: itemClass,
                to: '/creative',
                activeClassName: activeClassName,
                onClick: this.closeNav.bind(this)
              },
              'creative'
            ),
            _react2.default.createElement(
              _PageLink2.default,
              {
                isDark: isDark,
                className: itemClass,
                to: '/technical',
                activeClassName: activeClassName,
                onClick: this.closeNav.bind(this)
              },
              'technical'
            ),
            _react2.default.createElement(
              _PageLink2.default,
              {
                isDark: isDark,
                className: itemClass,
                to: '/publishing',
                activeClassName: activeClassName,
                onClick: this.closeNav.bind(this)
              },
              'catalogue'
            ),
            _react2.default.createElement(
              _PageLink2.default,
              {
                isDark: isDark,
                className: itemClass,
                to: '/work',
                activeClassName: activeClassName,
                onClick: this.closeNav.bind(this)
              },
              'our work'
            ),
            _react2.default.createElement(
              _PageLink2.default,
              {
                isDark: isDark,
                className: itemButtonClass,
                to: '/contact',
                activeClassName: activeClassName,
                onClick: this.closeNav.bind(this)
              },
              _react2.default.createElement('span', { className: _generalNav2.default.borderT }),
              _react2.default.createElement('span', { className: _generalNav2.default.borderR }),
              _react2.default.createElement('span', { className: _generalNav2.default.borderB }),
              _react2.default.createElement('span', { className: _generalNav2.default.borderL }),
              'contact'
            )
          )
        )
      );
    }
  }]);

  return Navigation;
}(_react.Component);

Navigation.propTypes = {
  isHome: _react.PropTypes.bool.isRequired
};

Navigation.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};

exports.default = Navigation;


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/Navigation.js
// module id = 325
// module chunks = 1